import { useExternalParams } from 'shared/hooks';
import { DateTime } from 'luxon';
import { PaymentsFilters } from './use-payments-filters.types';

const initialValues = {
  creationDate: {
    initialValue: DateTime.now(),
    type: 'date',
  },
  workerId: {
    initialValue: undefined,
    type: 'string',
  },
  invoiceReference: {
    initialValue: undefined,
    type: 'string',
  },
  status: {
    initialValue: undefined,
    type: 'string_array',
  },
  dueDate: {
    initialValue: undefined,
    type: 'date',
  },
} as const;

export const usePaymentsPage = () => {
  const [params, setParams] = useExternalParams(initialValues);

  const filters: PaymentsFilters = {
    creationDate: params.creationDate,
    workerId: params.workerId,
    invoiceReference: params.invoiceReference,
    status: params.status,
    dueDate: params.dueDate,
  };
  const selectedFilterCount = Object.values(filters).filter((value) => !!value).length;

  return {
    filters,
    setFilters: setParams,
    selectedFilterCount,
  };
};
